<div class="verfy-wrap">
  <div class="verfy-screen-logo">
    <img
      alt=""
      class="verify-agency-logo"
      src="assets/images/io-logo-green.svg"
    />
  </div>
  <div class="verfy-box">
    <div *ngIf="isLoading">
      <p>Verifying link...</p>
    </div>

    <div *ngIf="!isLoading && isAllowed">
      <h2>Download Report</h2>
      <p>Enter your password to download the report.</p>
      <form (ngSubmit)="submit()">
        <div class="password-wrapper table-search-wrapper">
          <input
            class="table-search-field"
            type="password"
            [(ngModel)]="password"
            name="password"
            placeholder="Password"
          />
        </div>
        <button class="w-full mt-4" pButton type="submit">{{ hasSubmittedSuccessfully ? 'Resubmit' : 'Submit' }}</button>
      </form>
    </div>

    <div *ngIf="!isLoading && !isAllowed">
      <h2>Forbidden</h2>
      <p>{{ default_message }}</p>
    </div>
  </div>
  <div class="powered-wrapper">
    <span class="text-center">Powered by</span>
    <div class="image-wrapper">
      <img alt="" src="assets/images/io-logo-green.svg" />
    </div>
  </div>
</div>
